import Vue from 'vue'
import "babel-polyfill"
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        isShowOptionSubmit:false,
        roleForwardRadioTurn:null,
        allForwardRadioTurn:null,
        roleForwardTurn:null,
        roleForwardList:[],
        instanceRoleSupplyProcess:null,
        ssoToken:null,
        BRZZ:null,//补人终止
        personSelectedTrue:null,
        noPersonTextTurn:null,
        saveNewTableData:[],
        componentType:null,
        submitControl:null,
        isfirstExpand:true,
        messageSubmitFather:null,
        redColor: '#FA5F87',
        isSupplyRole:null,
        // paperShow:false,//业务信息页面添加审批人的显示
        // paperStatus:'',//
        // activityId:'',
        // paperType:'',
        roleActivityName:null,
        isOtherObj:{},
        btnTurn:true,
        hasIsAssigin:null,
        quitObjList:[],
        noPersonActivityId:[],
        blockedActivityInstId:null,
        noPersonActivityNameList:[],
        AddInfo:'',
        orgPersonUserId: '',
        instanceId:'',
        orgPersonUserName: '',
        noteMessage:'',
        roleCodeList:[],
        approvalRoleOpinion:'',
        examineList:[],
        isShowTab:true,
        needRole:true,
        supplePersonObj:{},
        supRolecode:'',
        supRoleName:'',
        onlyReadHide:true,
        isShowBtnMobile:true,
        reloadTabRole:false, //角色提示信息
        supRoleType:null,
        optionTips:null,
        isLongforShuanghu:null,
        hasNewTable:true,
        iframeTime:null,
        startRoleSupplyProcess:null,
        leaveRoleSupplyProcess:null,
        reloadTurn:null,
        addOrg:undefined,
        unableAssignActivity:null,
        meassageOpinion:'',
        processExplain:{processExplainSystem:'',processExplainTemplate:''},
        appoint:null,
        defaultProcess:null,
        roleProcess:null,
        nextActivityDefId:null,
        currentParticipant:{},
        usercode:null,
        buttonArgument:{
            vm:null, type:null, opinion:null, file:null, actionName:null,activityId:null,info:null,checkTurn:null
        },
        loadtime:false,
        permission:true,
        tabMessage:'',
        isOtherPerson:false,
        upFlag:true,
        leftButton:null,
        refluxStrategy:'next',
        iosWidth:false,
        contentSendOther:{
            participants: {attributes:{}},
            attachmentRelation: [],
            opinion: ""
        },
        saveObj:null,
        content: {
            participants: [],
            attachmentRelation: [],
            assignOpinion: "non enim"
          },
        isPadding:true,
       negotiatePerson:{},
       isShowOptionBox:true,
       tabNum:0,
       negotiatorsTurn:false,
       isShow:false,
        btnHide:true,
        tabHide:true,
        plusShow:false,
        options: ['a', 'b', 'c'],
        urlParam: {},
        isPc: true,
        addTab:[],
        plusList:{},
        searchText:{  // 加签
            chsList:[],  // 添加人员
            chsListInfo:{},  // 确定人员
            pageList:[],  //  表格数据
            totalPage: 0,  // 总页数
            pageSize: 10,  // 每页显示个数
            currentPage:1,  // 当前页数
            currentPageOther:1,// 外部人员当前页数
            inputVal:'',  // 搜索内容
            orgId:'',  // 组织机构id
            flag:null,  // 展示搜索类型'1,2'
            flagTree:3, // 树导航flag
            bizCode:'',  // 维度类型
            namePath:null
        },
        approvalTableData:[],//存储加签后的审批步骤列表数据数据 ，提交前用于判断审批人是否为空
        hasAddLabel:0,//加签一次则自增1，审批信息页面监听后会更新表格
        addLabelParam:null,//加签时选择的审批信息
        approvalOpinion:'', //提交处理意见
        processInstID: '',  // 上传附件，流程/活动实例ID
        activityInstID: '',
        showIframe:'iframeForm_hide',
        operatorList: [],//现已有的所有流程信息
        addLableList:[],   // 加签时已有人员保存
        tableData:[],
        currentActivityDefId:'',   // 当前环节id
        params:[],
        getReload:0,
        ucAndManagerIdArr: [],

        //  examine.vue
        checkedValue: '',
        activityIdd: '',
        isShowBtnBox:true,
        iframeWinRead: '', // 阅读记录的iframe
        isScreenDirectionVertical: true, // 是否是竖屏
        groupId:"",//交圈群id
        IS_IN_YTS_DESKTOP: window.jsBridge && window.jsBridge.runEnvyts,
        IS_IN_YTS_WEB: false,//是否是在云图梭web中打开的
        IS_IN_YTS_WEB_OUT:false,//是否是在云图梭web的待办中打开的
        BPM_FROM_ENV:"",//从何处打开的bpm ["YTS_DESKTOP","YTS_WEB","TODO_DESKTOP","TODO_WEB"]
    },
    getters: {
        b: function (state) {
            return state.a += 6
        }
    },
    mutations: {
        setIsScreenDirectionVertical(state,payload) {
          state.isScreenDirectionVertical = payload;
        },
        setCheckedValue (state, sPayload) {
          Vue.set(state, 'checkedValue', sPayload)
        },
        setActivityIdd (state, sPayload) {
          Vue.set(state, 'activityIdd', sPayload)
        },
        addLabelParam:function(state,data){
            state.addLabelParam = data;
        },
        recordState: function (state, data) {
            state.processInfo = data;
        },
        recordaddTabState: function(state, data){
            state.addTab = data;
        },
        searchText:function(state,data){
            state.searchText.pageList = data.personInfo;
            state.searchText.totalPage = Number(data.pageTotal);
        },
        totalPage:function(state,data){
            state.totalPage = Number(data);
        },
        orgId:function(state,data){
            state.searchText.orgId = data;
        },
        flag:function(state,data){
            state.searchText.flag = data;
        },
        namePath:function(state,data){
            state.searchText.namePath = data;
        },
        flagTree:function(state,data){
            state.searchText.flagTree = data;
        },
        chsList:function(state,data){
            state.searchText.chsList = data;
        },
        chsListInfo:function(state,data,rowId){
            state.searchText.chsListInfo[rowId] = data;
        },
        addTab:function(state,data){
            state.addTab = data;
        },
        bizCode:function(state,data){
            state.searchText.bizCode = data;
        },
        processInstID:function(state, data) {
            state.processInstID = data.processInstID;
        },
        activityInstID:function(state, data) {
            state.activityInstID = data.activityInstID;
        },
        showIframe:function(state, data){
            state.showIframe = data;
        },
        approvalOpinion:function(state,data){
            state.approvalOpinion = data
        },
        operatorList:function(state,data) {
            state.operatorList = data
        },
        getReload:function(state,data){
            state.getReload++
        },
        setUcAndManagerIdArr(state,data){
            state.ucAndManagerIdArr = data
        },
    },
    actions: {
        recordState: function (context, data) {
            context.commit('recordState', data)
        },
        // showIframe:function(context, data){
        //     context.commit('showIframe',data)
        // }
    },
    defaultProcess:null,
        participant:null,
        btnParams:null,
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js